// VWO Event Tracking for Checkout Buttons
(function() {
  var VWO_EVENT_NAME = 'checkoutButtonClicked';
  
  // VWO reference code initialization (ensures VWO.event works correctly)
  window.VWO = window.VWO || [];
  window.VWO.event = window.VWO.event || function () {
    window.VWO.push(['event'].concat([].slice.call(arguments)));
  };
  
  function trackCheckoutButtonClick() {
    try {
      // Call VWO event exactly as documented
      window.VWO.event(VWO_EVENT_NAME);
      console.log('[VWO] Event fired:', VWO_EVENT_NAME);
    } catch (err) {
      console.error('[VWO] trackEvent error:', err);
    }
  }

  // Use delegated events from document - can't be removed by .off('click') on buttons
  $(document).ready(function() {
    $(document).on('click.vwoEventTracking', '[id^="VWO-checkout-button-"]', function() {
      trackCheckoutButtonClick();
    });
  });
})();

// ============================================================
// TOGGLE: Set to true to show popup upsell, false for direct checkout
// ============================================================
const SHOW_POPUP_UPSELL = true;

// Expose to global scope so VWO can access it
window.currentVariantId = null;

// ============================================================
// Android Device Detection
// ============================================================
window.isAndroidDevice = function() {
  // Check for test parameter first
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('test_android') === 'true') {
    return true;
  }
  // Check user agent for actual Android devices
  return /Android/i.test(navigator.userAgent);
};

// Store detection result globally
window.isAndroid = window.isAndroidDevice();

// Helper functions exposed globally for VWO injection
window.clearCartBeforeAdd = function() {
  return fetch("/cart/clear.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  })
    .then(() => console.log("Cart cleared before adding new product"))
    .catch((err) => console.warn("Cart clear failed before add", err));
};

// Placeholder - will be properly defined once addToCartAndCheckout is available
window.checkoutWithCurrentVariant = function() {
  console.error("checkoutWithCurrentVariant called before initialization");
  return Promise.resolve();
};

// Default US customer checkout behavior
// Controlled by SHOW_POPUP_UPSELL flag above
window.handleUSCustomerCheckout = function(variantId) {
  const allowedIds = [51380566524117, 51380566556885, 51380566589653, 51380566622421, 52795181498581, 52795181531349, 52795181564117, 52795181596885];
  
  // If popup upsell is enabled and this is an iOS mic variant
  if (SHOW_POPUP_UPSELL && allowedIds.includes(variantId)) {
    console.log("US customer (Case B): Showing popup for variant", variantId);
    $('#studioPlusMonthlyPopup').css("display", "flex");
  } else {
    // Direct to checkout (Case A)
    console.log("US customer (Case A): Going straight to checkout:", variantId);
    window.checkoutWithCurrentVariant();
  }
};

$(document).ready(function () {
  $(".hummenu_container").on("click", function () {
    $(".overlay").addClass("active");
    $("html").css("overflow", "hidden"); 
  });

  $(".overlay-close").on("click", function () {
    $(".overlay").removeClass("active");
    $("html").css("overflow", ""); 
  });

  const $checkoutButtons = $(".popUpBtn");
  const $directCheckoutButtons = $(".no-upsell-button");
  const $checkoutPopup = $("#checkoutPopup");
  const $proPlanPopup = $("#proPlanPopup");
  const $studioPlusMonthlyPopup = $("#studioPlusMonthlyPopup");
  const $studioPlusAnnualPopup = $("#studioPlusAnnualPopup");
  const $justMicButton = $(".just-mic-button");
  const $closePopupBtn = $("#closeBTn");
  const $closeProPlanBtn = $("#closeProPlanBtn");
  const $closeStudioPlusMonthlyBtn = $("#closeStudioPlusMonthlyBtn");
  const $closeStudioPlusAnnualBtn = $("#closeStudioPlusAnnualBtn");
  const $proPlanLabel = $(".Pro_plan_label");
  const $studioPlanLabel = $(".studio_plan_label");

  $checkoutButtons.on("click", function () {
    window.currentVariantId = $(this).data("variant-id");
    console.log("Variant set:", window.currentVariantId);
    if (!window.currentVariantId) {
      alert("Error: Missing product variant. Please refresh the page.");
      return;
    }
    $checkoutPopup.css("display", "flex");
  });

  $directCheckoutButtons.on("click", function () {
    const $btn = $(this);
    window.currentVariantId = $btn.data("variant-id");
    window.currentButton = $btn; // Store button for VWO access
    const isUSCustomer = $btn.data("is-us-customer");
    
    console.log("Direct checkout variant set:", window.currentVariantId, "US customer:", isUSCustomer);
    
    if (!window.currentVariantId) {
      alert("Error: Missing product variant. Please refresh the page.");
      return;
    }
    
    // Non-US customers always go straight to checkout (no upsells)
    if (!isUSCustomer) {
      console.log("Non-US customer: bypassing upsells, going to checkout");
      checkoutWithCurrentVariant();
      return;
    }
    
    // US customers: use routing function (VWO can override)
    window.handleUSCustomerCheckout(window.currentVariantId);
  });

  $proPlanLabel.on("click", function () {
    $checkoutPopup.hide();
    $proPlanPopup.css("display", "flex");
  });
  $studioPlanLabel.on("click", function () {
    $proPlanPopup.hide();
    $checkoutPopup.css("display", "flex");
  });

  $justMicButton.on("click", function() {
    window.checkoutWithCurrentVariant();
  });

  function addToCartAndCheckout(variantId) {
    console.log("Adding to cart:", variantId);
    $.ajax({
      url: "/cart/add.js",
      method: "POST",
      dataType: "json",
      data: {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      },
      success: function (response) {
        console.log("Cart response:", response);
        localStorage.setItem("goingToCheckout", "true");
        localStorage.setItem("checkoutStartedAt", String(Date.now()));
        window.location.href = "/checkout";
      },
      error: function (error) {
        console.error("Cart error:", error.responseJSON || error);
        alert(
          `Error: ${
            error.responseJSON?.description || "Could not add to cart."
          }`
        );
      },
    });
  }

  // Now that addToCartAndCheckout is defined, properly set up the global function
  window.checkoutWithCurrentVariant = function() {
    if (!window.currentVariantId) {
      alert("Please select a plan first.");
      return Promise.resolve();
    }

    return window.clearCartBeforeAdd().then(() => {
      addToCartAndCheckout(window.currentVariantId);
    });
  };

  const AddOnPlusMainVariantAddToCart = (mainBtn) => {
    let finalProdForCart = [];
    const addOnVariantId = mainBtn.attr("data-sub-variant-id");
    const sellingPlanId = mainBtn.attr("data-selling-plan-id");
    const planName = mainBtn.attr("data-planName");

    // Determine subscription properties based on plan type
    let subscriptionProperties = {};
    if (planName === "Studio Plus Monthly") {
      subscriptionProperties = {
        _sub_len: "1",
        _sub_period: "month",
        _sub_has_trial: "true",
        _sub_trial_len: "30",
        _sub_trial_period: "days",
        _sub_price: "15",
        _sub_spid: String(sellingPlanId),
      };
    } else if (planName === "Studio Plus Annual") {
      subscriptionProperties = {
        _sub_len: "1",
        _sub_period: "year",
        _sub_has_trial: "true",
        _sub_trial_len: "30",
        _sub_trial_period: "days",
        _sub_price: "99",
        _sub_spid: String(sellingPlanId),
      };
    }

    if (!mainBtn.data("original-html")) {
      mainBtn.data("original-html", mainBtn.html());
    }

    mainBtn
      .empty()
      .html(`<span class="button is-loading is-loading--icon-only"></span>`)
      .addClass("focused");

    clearCartBeforeAdd().then(() => {
      finalProdForCart.push(
        {
          id: addOnVariantId,
          quantity: 1,
          selling_plan: sellingPlanId,
          properties: subscriptionProperties,
        },
        { id: window.currentVariantId, quantity: 1, properties: {} }
      );

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { items: finalProdForCart },
        dataType: "json",
        success: function () {
          localStorage.setItem("goingToCheckout", "true");
          localStorage.setItem("checkoutStartedAt", String(Date.now()));

          mainBtn.empty().html("Added").addClass("focused");

          setTimeout(() => {
            window.location.href = "/checkout";
          }, 1000);
        },
        error: function () {
          mainBtn
            .empty()
            .html(mainBtn.data("original-html"))
            .removeClass("focused");
        },
      });
    });
  };

  $closePopupBtn.on("click", () => $checkoutPopup.hide());
  $closeProPlanBtn.on("click", () => $proPlanPopup.hide());
  $closeStudioPlusMonthlyBtn.on("click", () => $studioPlusMonthlyPopup.hide());
  $closeStudioPlusAnnualBtn.on("click", () => $studioPlusAnnualPopup.hide());
  $(document).on("click", ".subscription_btn", function () {
    AddOnPlusMainVariantAddToCart($(this));
  });

  $(document).on("click", ".checkout", function () {
    localStorage.setItem("goingToCheckout", "true");
    localStorage.setItem("checkoutStartedAt", String(Date.now()));
  });

  const clearCartAfterCheckout = () => {
    if (localStorage.getItem("goingToCheckout") !== "true") return;

    const ref = document.referrer || "";
    const cameFromCheckout =
      ref.includes("/checkouts/") || ref.includes("/checkout");

    if (!cameFromCheckout) return;

    const startedAt = Number(localStorage.getItem("checkoutStartedAt") || 0);
    const within2Hours =
      startedAt && Date.now() - startedAt < 2 * 60 * 60 * 1000;
    if (!within2Hours) return;

    localStorage.removeItem("goingToCheckout");
    localStorage.removeItem("checkoutStartedAt");

    fetch("/cart/clear.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => {
        if (res.ok) {
          if (typeof theme !== "undefined" && theme.cart?.getCart) {
            theme.cart.getCart();
          }
          console.log("Cart cleared after returning from checkout");
        }
      })
      .catch((err) => console.error("Error clearing cart after checkout:", err));
  };

  clearCartAfterCheckout();

  // ============================================================
  // Homepage Android Button Routing
  // ============================================================
  if (window.location.pathname === '/' || window.location.pathname === '') {
    if (window.isAndroid) {
      console.log('[Android Detection] Detected Android device on homepage, routing to Android product');
      // Find all Order Now buttons and update their hrefs
      $('a[href*="/products/wireless-mic-and-ios-app"]').each(function() {
        const $link = $(this);
        const currentHref = $link.attr('href');
        // Only update if it's actually pointing to iOS product
        if (currentHref && currentHref.includes('wireless-mic-and-ios-app')) {
          const newHref = currentHref.replace('wireless-mic-and-ios-app', 'wireless-mic-and-android-app');
          $link.attr('href', newHref);
          console.log('[Android Detection] Updated button href to:', newHref);
        }
      });
    }
  }

  $closePopupBtn.on("click.preventReopen", function (e) {
    e.preventDefault();
    e.stopPropagation();
    setTimeout(() => {
      $checkoutPopup.css("display", "flex");
      $("html").css("overflow", "hidden");
    }, 0);
  });
  $closeProPlanBtn.on("click.preventReopen", function (e) {
    e.preventDefault();
    e.stopPropagation();
    setTimeout(() => {
      $proPlanPopup.css("display", "flex");
      $("html").css("overflow", "hidden");
    }, 0);
  });
  $closeStudioPlusMonthlyBtn.on("click.preventReopen", function (e) {
    e.preventDefault();
    e.stopPropagation();
    setTimeout(() => {
      $studioPlusMonthlyPopup.css("display", "flex");
      $("html").css("overflow", "hidden");
    }, 0);
  });
  $closeStudioPlusAnnualBtn.on("click.preventReopen", function (e) {
    e.preventDefault();
    e.stopPropagation();
    setTimeout(() => {
      $studioPlusAnnualPopup.css("display", "flex");
      $("html").css("overflow", "hidden");
    }, 0);
  });

  $checkoutPopup.on("mousedown.dismissOutside", function (e) {
    if (e.target === this) {
      $(this).hide();
      $("html").css("overflow", "");
      popModalStateIfAny(); 
    }
  });
  $proPlanPopup.on("mousedown.dismissOutside", function (e) {
    if (e.target === this) {
      $(this).hide();
      $("html").css("overflow", "");
      popModalStateIfAny();
    }
  });
  $studioPlusMonthlyPopup.on("mousedown.dismissOutside", function (e) {
    if (e.target === this) {
      $(this).hide();
      $("html").css("overflow", "");
      popModalStateIfAny();
    }
  });
  $studioPlusAnnualPopup.on("mousedown.dismissOutside", function (e) {
    if (e.target === this) {
      $(this).hide();
      $("html").css("overflow", "");
      popModalStateIfAny();
    }
  });

  $(document).on("mousedown.dismissOutsideDoc", function (e) {
    if ($checkoutPopup.is(":visible") && !$(e.target).closest("#checkoutPopup").length) {
      $checkoutPopup.hide();
      $("html").css("overflow", "");
      popModalStateIfAny();
    }
    if ($proPlanPopup.is(":visible") && !$(e.target).closest("#proPlanPopup").length) {
      $proPlanPopup.hide();
      $("html").css("overflow", "");
      popModalStateIfAny();
    }
    if ($studioPlusMonthlyPopup.is(":visible") && !$(e.target).closest("#studioPlusMonthlyPopup").length) {
      $studioPlusMonthlyPopup.hide();
      $("html").css("overflow", "");
      popModalStateIfAny();
    }
    if ($studioPlusAnnualPopup.is(":visible") && !$(e.target).closest("#studioPlusAnnualPopup").length) {
      $studioPlusAnnualPopup.hide();
      $("html").css("overflow", "");
      popModalStateIfAny();
    }
  });

  $(document).on("keydown.dismissEsc", function (e) {
    if (e.key === "Escape" || e.keyCode === 27) {
      let closed = false;
      if ($checkoutPopup.is(":visible")) {
        $checkoutPopup.hide();
        closed = true;
      }
      if ($proPlanPopup.is(":visible")) {
        $proPlanPopup.hide();
        closed = true;
      }
      if ($studioPlusMonthlyPopup.is(":visible")) {
        $studioPlusMonthlyPopup.hide();
        closed = true;
      }
      if ($studioPlusAnnualPopup.is(":visible")) {
        $studioPlusAnnualPopup.hide();
        closed = true;
      }
      if (closed) {
        $("html").css("overflow", "");
        popModalStateIfAny();
      }
    }
  });

  let _activeModalKey = null; 

  function pushModalState(key) {
    if (_activeModalKey) return;
    try {
      history.pushState({ popup: key }, "", location.href);
      _activeModalKey = key;
    } catch (e) {}
  }

  function popModalStateIfAny() {
    if (!_activeModalKey) return;
    const key = _activeModalKey;
    _activeModalKey = null;
    try {
      history.back();
    } catch (e) {}
  }

  $checkoutButtons.on("click.historyHook", function () {
    setTimeout(() => {
      if ($checkoutPopup.is(":visible")) pushModalState("checkout");
    }, 0);
  });
  $proPlanLabel.on("click.historyHook", function () {
    setTimeout(() => {
      if ($proPlanPopup.is(":visible")) pushModalState("pro");
    }, 0);
  });
  $studioPlanLabel.on("click.historyHook", function () {
    setTimeout(() => {
      if ($checkoutPopup.is(":visible")) pushModalState("checkout");
    }, 0);
  });

  const mo = new MutationObserver(() => {
    const checkoutOpen = $checkoutPopup.is(":visible");
    const proOpen = $proPlanPopup.is(":visible");
    const studioPlusMonthlyOpen = $studioPlusMonthlyPopup.is(":visible");
    const studioPlusAnnualOpen = $studioPlusAnnualPopup.is(":visible");
    if (checkoutOpen && !_activeModalKey) pushModalState("checkout");
    else if (proOpen && !_activeModalKey) pushModalState("pro");
    else if (studioPlusMonthlyOpen && !_activeModalKey) pushModalState("studioPlusMonthly");
    else if (studioPlusAnnualOpen && !_activeModalKey) pushModalState("studioPlusAnnual");
  });
  if ($checkoutPopup[0]) mo.observe($checkoutPopup[0], { attributes: true, attributeFilter: ["style", "class"] });
  if ($proPlanPopup[0]) mo.observe($proPlanPopup[0], { attributes: true, attributeFilter: ["style", "class"] });
  if ($studioPlusMonthlyPopup[0]) mo.observe($studioPlusMonthlyPopup[0], { attributes: true, attributeFilter: ["style", "class"] });
  if ($studioPlusAnnualPopup[0]) mo.observe($studioPlusAnnualPopup[0], { attributes: true, attributeFilter: ["style", "class"] });

  window.addEventListener("popstate", function () {
    if ($checkoutPopup.is(":visible") || $proPlanPopup.is(":visible") || $studioPlusMonthlyPopup.is(":visible") || $studioPlusAnnualPopup.is(":visible")) {
      $checkoutPopup.hide();
      $proPlanPopup.hide();
      $studioPlusMonthlyPopup.hide();
      $studioPlusAnnualPopup.hide();
      $("html").css("overflow", "");
      _activeModalKey = null;
      return;
    }
    if (_activeModalKey) _activeModalKey = null;
  });
});

// ========================================
// Audigo Country Selector Component
// ========================================
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="country_code"]'),
      button: this.querySelector('.country-selector__button'),
      closeButton: this.querySelector('.country-selector__close'),
      dropdown: this.querySelector('.country-selector__dropdown'),
    };
    
    this.elements.button.addEventListener('click', this.toggleSelector.bind(this));
    this.elements.closeButton.addEventListener('click', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    
    this.querySelectorAll('.country-selector__link').forEach(item => {
      item.addEventListener('click', this.onItemClick.bind(this));
    });
    
    // Close on outside click
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target) && !this.elements.dropdown.hasAttribute('hidden')) {
        this.closeSelector();
      }
    });
  }

  toggleSelector() {
    const isHidden = this.elements.dropdown.hasAttribute('hidden');
    if (isHidden) {
      this.openSelector();
    } else {
      this.closeSelector();
    }
  }

  openSelector() {
    this.elements.dropdown.removeAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', 'true');
    this.elements.button.classList.add('is-open');
  }

  closeSelector() {
    this.elements.dropdown.setAttribute('hidden', '');
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.button.classList.remove('is-open');
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE') {
      this.closeSelector();
      this.elements.button.focus();
    }
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

// Register the custom element
if (typeof customElements !== 'undefined' && !customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}
